import React from 'react'
import { LOYALTY_TIER } from 'modules/loyalty/constants'
import getCurTierNameLoyaltySelect from 'modules/loyalty/redux/selectors/get-cur-tier-name'
import useSelector from 'hooks/use-selector'
import View from 'components/View'
import getRandomNumberUtil from 'utils/number/get-random'
import './index.css'

const TIER_NAME_TO_ICON = {
  [LOYALTY_TIER.SILVER]: () => {
    const id = getRandomNumberUtil()
    return (
      <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M18.7654 8.14341L20.3374 10.5638L28.8662 12.5083L18.2512 24.9485L15.924 23.7037L7.84345 27.5009L8.73985 18.4778L18.7654 8.14341Z'
          fill={`url(#paint0_linear_1240_315316-${id})`}
        />
        <path
          d='M15.5018 3.51654C15.7056 3.10363 16.2944 3.10362 16.4982 3.51654L19.5942 9.78976C19.9276 10.4653 20.5721 10.9335 21.3176 11.0419L28.2405 12.0478C28.6962 12.114 28.8781 12.674 28.5484 12.9954L23.5389 17.8785C22.9995 18.4043 22.7533 19.1619 22.8807 19.9044L24.0632 26.7993C24.1411 27.2532 23.6647 27.5993 23.2571 27.385L17.0651 24.1297C16.3983 23.7791 15.6017 23.7791 14.9349 24.1297L8.74285 27.385C8.33528 27.5993 7.85893 27.2532 7.93677 26.7993L9.11935 19.9044C9.2467 19.1619 9.00053 18.4043 8.46107 17.8784L3.45161 12.9954C3.12188 12.674 3.30382 12.114 3.7595 12.0478L10.6824 11.0419C11.4279 10.9335 12.0724 10.4653 12.4058 9.78976L15.5018 3.51654Z'
          stroke='#191531'
          strokeWidth='1.73333'
        />
        <defs>
          <linearGradient
            id={`paint0_linear_1240_315316-${id}`}
            x1='17.1281'
            y1='15.0677'
            x2='19.1313'
            y2='18.8665'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#DAD8E4' />
            <stop offset='1' stopColor='#EEF0FF' />
          </linearGradient>
        </defs>
      </svg>
    )
  },
  [LOYALTY_TIER.GOLD]: () => {
    const id = getRandomNumberUtil()
    return (
      <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M4.29358 11.2484L6.54573 20.82C6.61659 21.1212 6.88531 21.334 7.19468 21.334H25.4407C25.7642 21.334 26.041 21.1017 26.0972 20.7832L27.7994 11.1376C27.8885 10.6322 27.3973 10.2198 26.915 10.3952L21.1696 12.4844C20.8758 12.5913 20.5472 12.4796 20.3793 12.2158L16.5257 6.16006C16.2733 5.76341 15.7006 5.74563 15.4241 6.12586L10.9718 12.2478C10.7923 12.4945 10.4683 12.588 10.185 12.4747L5.19012 10.4767C4.6891 10.2763 4.16999 10.7231 4.29358 11.2484Z'
          fill='#F3D1A1'
        />
        <path
          d='M5.46263 25.2237L5.90707 22.5571C5.96065 22.2356 6.23878 22 6.56467 22H25.4352C25.7611 22 26.0392 22.2356 26.0928 22.5571L26.5372 25.2237C26.6049 25.6301 26.2916 26 25.8796 26H6.12023C5.70827 26 5.3949 25.6301 5.46263 25.2237Z'
          fill='#EBC188'
        />
        <path
          d='M25.1283 8.84798C25.9269 8.36398 26.903 8.39735 27.6683 8.93335C28.435 9.47068 28.799 10.3733 28.6176 11.292C28.615 11.3 28.6136 11.308 28.6122 11.316L26.447 21.0013L27.1857 25.3907C27.267 25.876 27.1323 26.3694 26.815 26.744C26.4963 27.12 26.0336 27.3347 25.5416 27.3347H5.78559C5.29359 27.3347 4.82965 27.1187 4.51231 26.744C4.19631 26.368 4.06029 25.8747 4.14163 25.3907L4.88032 21.0013L2.71495 11.316C2.52828 10.3733 2.8923 9.46935 3.65896 8.93335C4.4243 8.39735 5.39892 8.36398 6.19892 8.84798L9.51899 10.856C9.66432 10.9453 9.8536 10.9027 9.94827 10.76L13.731 5.03866C14.1617 4.38799 14.8829 4 15.663 4C16.443 4 17.1642 4.38799 17.5949 5.03866L21.3816 10.764C21.475 10.904 21.659 10.9454 21.8043 10.8587L25.1283 8.84798Z'
          fill={`url(#paint0_linear_1240_486396-${id})`}
        />
        <path
          d='M26.8148 26.743C26.4962 27.119 26.0335 27.3337 25.5415 27.3337H17.3447L28.6175 11.291C28.6175 11.291 27.1701 17.7638 26.4468 21.0004L27.1855 25.3897C27.2669 25.875 27.1322 26.3684 26.8148 26.743Z'
          fill={`url(#paint1_linear_1240_486396-${id})`}
        />
        <path
          d='M15.663 4C16.443 4 18.9962 7.66667 18.9962 7.66667L5.66284 26.3333L4.88032 21.0013L2.71495 11.316C2.52828 10.3733 2.8923 9.46935 3.65896 8.93335C4.4243 8.39735 5.39892 8.36398 6.19892 8.84798L9.51899 10.856C9.66432 10.9453 9.8536 10.9027 9.94827 10.76L13.731 5.03866C14.1617 4.38799 14.8829 4 15.663 4Z'
          fill={`url(#paint2_linear_1240_486396-${id})`}
        />
        <path
          d='M27.6683 8.93335C26.903 8.39735 25.9269 8.36398 25.1283 8.84798L21.8043 10.8587C21.659 10.9454 21.475 10.904 21.3816 10.764L17.5949 5.03866C17.1642 4.38799 16.443 4 15.663 4C14.8829 4 14.1617 4.38799 13.731 5.03866L9.94827 10.76C9.8536 10.9027 9.66432 10.9453 9.51899 10.856L6.19892 8.84798C5.39892 8.36398 4.4243 8.39735 3.65896 8.93335C2.8923 9.46935 2.52828 10.3733 2.71495 11.316L4.88032 21.0013L4.14163 25.3907C4.06029 25.8747 4.19631 26.368 4.51231 26.744C4.82965 27.1187 5.29359 27.3347 5.78559 27.3347H25.5416C26.0336 27.3347 26.4963 27.12 26.815 26.744C27.1323 26.3694 27.267 25.876 27.1857 25.3907L26.447 21.0013L28.6122 11.316C28.6136 11.308 28.615 11.3 28.6176 11.292C28.799 10.3733 28.435 9.47068 27.6683 8.93335ZM6.17898 25.3333L6.74026 22H24.5869L25.1483 25.3333H6.17898ZM24.6216 20H6.70559L4.67092 10.904C4.63492 10.7213 4.73894 10.6173 4.80561 10.572C4.86961 10.5253 5.00425 10.464 5.16425 10.56L8.48294 12.568C9.55227 13.2147 10.927 12.904 11.6163 11.864L15.399 6.14266C15.563 5.89466 15.7629 5.89466 15.9269 6.14266L19.7123 11.8667C20.4003 12.9067 21.7723 13.2147 22.839 12.5707L26.1629 10.56C26.3216 10.464 26.4563 10.5253 26.5216 10.572C26.5856 10.6173 26.6882 10.7187 26.6576 10.896L24.6216 20Z'
          fill='#191531'
        />
        <defs>
          <linearGradient
            id={`paint0_linear_1240_486396-${id}`}
            x1='15.6651'
            y1='4'
            x2='15.6651'
            y2='27.3347'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#FFCF52' />
            <stop offset='1' stopColor='#FFD076' />
          </linearGradient>
          <linearGradient
            id={`paint1_linear_1240_486396-${id}`}
            x1='23.5549'
            y1='20.6293'
            x2='18.355'
            y2='16.9948'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#FDF3DD' />
            <stop offset='1' stopColor='white' />
          </linearGradient>
          <linearGradient
            id={`paint2_linear_1240_486396-${id}`}
            x1='11.6628'
            y1='17'
            x2='4.32951'
            y2='11.6667'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#FDF3DD' />
            <stop offset='1' stopColor='white' />
          </linearGradient>
        </defs>
      </svg>
    )
  },
  [LOYALTY_TIER.DIAMOND]: () => {
    return (
      <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M16.5333 26.9418L21.749 10.5497H11.3176L16.5333 26.9418Z' fill='#EEF0FF' />
        <path d='M24.7294 5.33398L21.749 10.5497H28.6667L24.7294 5.33398Z' fill='#EEF0FF' />
        <path d='M11.3176 10.5497L8.33724 5.33398L4 10.5497H11.3176Z' fill='#EEF0FF' />
        <path d='M16.5333 5.33398L11.3176 10.5497H21.749L16.5333 5.33398Z' fill='#EEF0FF' />
        <path d='M21.749 10.5497L24.7294 5.33398H16.5333L21.749 10.5497Z' fill='#EEF0FF' />
        <path d='M8.33724 5.33398L11.3176 10.5497L16.5333 5.33398H8.33724Z' fill='#EEF0FF' />
        <path
          d='M24.7294 5.33398L21.749 10.5497M24.7294 5.33398L28.6667 10.5497M24.7294 5.33398H16.5333M21.749 10.5497L16.5333 26.9418M21.749 10.5497L16.5333 5.33398M21.749 10.5497H11.3176M21.749 10.5497H28.6667M16.5333 26.9418L11.3176 10.5497M16.5333 26.9418L4 10.5497M16.5333 26.9418L28.6667 10.5497M11.3176 10.5497L8.33724 5.33398M11.3176 10.5497L16.5333 5.33398M11.3176 10.5497H4M8.33724 5.33398L4 10.5497M8.33724 5.33398H16.5333'
          stroke='#2E22D3'
          strokeWidth='1.73333'
          strokeLinejoin='round'
        />
      </svg>
    )
  }
}

export default function LoyaltyTierIcon (props) {
  logUtil('LoyaltyTierIcon').debug('[start] props=', props)

  const Component = props.Component || View
  const tierName = useSelector(getCurTierNameLoyaltySelect)
  const name = props.tierName || tierName
  const func = TIER_NAME_TO_ICON[name]
  if (!func) {
    return <></>
  }

  const icon = func()
  const propsToPass = {}
  if (Component !== React.Fragment) {
    propsToPass.className = 'loyalty-tier-icon'
  }

  return (
    <Component {...propsToPass}>
      {icon}
    </Component>
  )
}
